import { Dialog, InfiniteScroll, SearchBar, Toast } from 'antd-mobile'
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react'
import {
    CulturalListItem,
    SearchHistoryItem,
    SearchRecommendItem,
} from 'src/components/CulturalComponent'
import { SearchOutline } from 'antd-mobile-icons'
import { useHistory } from 'react-router-dom'
import icon_delete from '../../assets/icon_delete.svg'
import axios from 'axios'
import './Index.scss'
interface IndexProps {}

const Index: FunctionComponent<IndexProps> = () => {
    const history = useHistory()
    const currentPage = useRef(1)
    const [listData, setListData] = useState([])

    const [hasMore, setHasMore] = useState(false)
    const loadMore = async value => {
        currentPage.current = currentPage.current + 1
        const res = await searchListData(true)
        setListData(listData => [...listData, ...res.items])
        setHasMore(res.hasNextPage)
    }

    const [showList, setShowList] = useState(true)
    // 搜索区域
    const [searchBarValue, setSearchBarValue] = useState('')
    const [searchBarPlaceholder, setSearchBarPlaceholder] = useState('')
    const [searchRecommendData, setSearchRecommendData] = useState([])
    const [searchHistoryData, setSearchHistoryData] = useState([])

    const searchInputClick = useCallback(
        (inputValue?: string) => {
            const value = inputValue || searchBarValue || searchBarPlaceholder
            setSearchBarValue(value)
            setHistoryLocalStorage(value)
            currentPage.current = 1
            setSearchFlag(true)
            setTimeout(() => {
                setShowList(true)
            }, 0)
        },
        [searchBarValue, searchBarPlaceholder, currentPage],
    )

    const setHistoryLocalStorage = useCallback((value?: string) => {
        const arr: string[] = JSON.parse(localStorage.getItem('search_history')) || []
        if (value && arr.indexOf(value) < 0) arr.unshift(value)
        if (arr.length > 20) arr.length = 20
        localStorage.setItem('search_history', JSON.stringify(arr))
        setSearchHistoryData(arr)
    }, [])
    // 跳转到详情
    const jumpToDetails = useCallback(item => {
        // history.push(`/detail/${item.id}`)
        history.push({
            pathname: '/detail',
            search: `id=${item.id}`,
        })
    }, [])
    // 自动触发
    const searchListData = useCallback(
        async (returnData?: boolean) => {
            // 发送 POST 请求

            const res = await axios({
                method: 'post',
                url: '/api/display',
                data: {
                    page: currentPage.current,
                    pageSize: 6,
                    keyword: searchBarValue,
                },
            })
            if (res.data.code !== 0) {
                Toast.show({
                    content: res.data.message,
                })
                return
            }

            if (returnData) {
                return res.data.data
            }
            setListData(res.data.data.items)
            setHasMore(res.data.data.hasNextPage)
        },
        [searchBarValue, currentPage],
    )
    const searchRecommend = useCallback(() => {
        // 发送 POST 请求
        axios({
            method: 'get',
            url: '/api/display/config',
        }).then(res => {
            const data = res.data.data.RecommendedSearch
            setSearchRecommendData(data)
            setSearchBarPlaceholder(data[Math.floor(Math.random() * data.length)])
        })
    }, [])
    const [searchFlag, setSearchFlag] = useState(false)
    useEffect(() => {
        if (searchFlag) {
            searchListData()
            setSearchFlag(false)
        }
    }, [searchFlag])
    useEffect(() => {
        searchRecommend()
        setSearchFlag(true)
        setHistoryLocalStorage()
    }, [])
    return (
        <div className="cultural-index">
            <div className="cultural-index-title">
                <h4>3D文物展示系统</h4>
                <SearchBar
                    placeholder={searchBarPlaceholder}
                    value={searchBarValue}
                    icon={
                        <SearchOutline
                            onClick={() => {
                                searchInputClick()
                            }}
                        />
                    }
                    showCancelButton
                    style={{
                        '--border-radius': '4px',
                        '--background': '#ffffff',
                        '--height': '40px',
                    }}
                    onFocus={() => {
                        setShowList(false)
                    }}
                    onChange={value => {
                        setSearchBarValue(value)
                    }}
                    onSearch={() => {
                        searchInputClick()
                    }}
                    onBlur={() => {
                        setShowList(true)
                    }}
                    onCancel={() => {
                        setSearchBarValue('')
                        currentPage.current = 1
                        setSearchFlag(true)
                        setTimeout(() => {
                            setShowList(true)
                        }, 0)
                    }}
                />
            </div>
            <div
                className="cultural-list-wrapper"
                style={{
                    display: showList ? '' : 'none',
                }}
                onClick={evt => {
                    evt.stopPropagation()
                }}
            >
                <div className="cultural-list">
                    {listData.map(item => {
                        return (
                            <CulturalListItem
                                key={item.id}
                                img={item.cover}
                                name={item.name}
                                onClick={() => {
                                    jumpToDetails(item)
                                }}
                            ></CulturalListItem>
                        )
                    })}
                </div>
                <InfiniteScroll hasMore={hasMore} loadMore={loadMore}  />
            </div>
            <div
                className="cultural-search-wrapper"
                style={{
                    display: showList ? 'none' : '',
                }}
                onClick={evt => {
                    evt.stopPropagation()
                }}
            >
                <div className="recommend">
                    <h4>推荐搜索</h4>
                    <div>
                        {searchRecommendData.map((item, index) => (
                            <SearchRecommendItem
                                onTouchEnd={() => {
                                    searchInputClick(item)
                                }}
                                key={index}
                            >
                                {item}
                            </SearchRecommendItem>
                        ))}
                    </div>
                </div>
                {searchHistoryData.length !== 0 && (
                    <div className="history">
                        <div className="title">
                            <h4>搜索历史</h4>
                            <img
                                src={icon_delete}
                                onTouchEnd={() => {
                                    Dialog.show({
                                        content: '确定要清空历史记录吗？',
                                        bodyClassName: 'delete-history',
                                        closeOnAction: true,
                                        actions: [
                                            [
                                                {
                                                    key: 'cancel',
                                                    className: 'history-btn',
                                                    text: '取消',
                                                },
                                                {
                                                    className: 'history-btn delete',
                                                    key: 'delete',
                                                    text: '删除',
                                                    onClick: () => {
                                                        localStorage.removeItem('search_history')
                                                        setSearchHistoryData([])
                                                    },
                                                },
                                            ],
                                        ],
                                    })
                                }}
                                alt=""
                            />
                        </div>
                        <div className="content">
                            {searchHistoryData.map((item, index) => (
                                <SearchHistoryItem
                                    onTouchEnd={() => {
                                        searchInputClick(item)
                                    }}
                                    key={index}
                                >
                                    {item}
                                </SearchHistoryItem>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Index
